// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GameCategoriesQueryVariables = Types.Exact<{
  categoriesFilter?: Types.InputMaybe<Types.CasinoMenuItemConnectionFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GameCategoriesQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, gameCategories?: { __typename?: 'CasinoMenuItemConnection', edges?: Array<{ __typename?: 'CasinoMenuItemEdge', node?: { __typename?: 'CasinoMenuItem', id: string, name?: string, handle?: string } }> } } };

export type GameCategoryFragment = { __typename?: 'CasinoMenuItem', id: string, name?: string, handle?: string };

export const GameCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment GameCategoryFragment on CasinoMenuItem {
  id
  name
  handle
}
    `;
export const GameCategoriesQueryDocument = /*#__PURE__*/ gql`
    query GameCategoriesQuery($categoriesFilter: CasinoMenuItemConnectionFilter, $first: Int) {
  casino {
    id
    gameCategories: menuItems(
      filter: $categoriesFilter
      sort: {order: 1}
      first: $first
    ) {
      edges {
        node {
          ...GameCategoryFragment
        }
      }
    }
  }
}
    ${GameCategoryFragmentDoc}`;
export function useGameCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GameCategoriesQuery, GameCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameCategoriesQuery, GameCategoriesQueryVariables>(GameCategoriesQueryDocument, options);
      }
export function useGameCategoriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameCategoriesQuery, GameCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameCategoriesQuery, GameCategoriesQueryVariables>(GameCategoriesQueryDocument, options);
        }
export function useGameCategoriesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GameCategoriesQuery, GameCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GameCategoriesQuery, GameCategoriesQueryVariables>(GameCategoriesQueryDocument, options);
        }
export type GameCategoriesQueryHookResult = ReturnType<typeof useGameCategoriesQuery>;
export type GameCategoriesQueryLazyQueryHookResult = ReturnType<typeof useGameCategoriesQueryLazyQuery>;
export type GameCategoriesQuerySuspenseQueryHookResult = ReturnType<typeof useGameCategoriesQuerySuspenseQuery>;
export type GameCategoriesQueryQueryResult = Apollo.QueryResult<GameCategoriesQuery, GameCategoriesQueryVariables>;